<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { setup, type Emit, type Props } from './noDataContent.setup';

defineProps<Props>();
const emit = defineEmits<Emit>();
const { onClick } = setup(emit);
</script>

<template>
  <div class="no-data-content">
    <div
      v-if="$slots.icon"
      class="no-data-content__icon"
    >
      <slot name="icon" />
    </div>
    <div class="no-data-content__message">
      <slot name="message">
        {{ message }}
      </slot>
    </div>
    <slot name="button">
      <base-button
        v-if="buttonTitle || $slots.buttonTitle"
        type="primary"
        size="medium"
        class="no-data-content__button"
        :disabled="btnDisabled"
        @click="onClick"
      >
        <slot name="buttonTitle"> {{ buttonTitle }} </slot>
      </base-button>
    </slot>
  </div>
</template>

<style scoped lang="scss">
.no-data-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__message {
    font-size: 14px;
    text-align: center;
    white-space: pre-line;
  }
  &__button {
    display: flex;
    gap: 4px;
    align-items: center;
  }
}
</style>
